import * as React from 'react';
import MuiAppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import SearchIcon from '@mui/icons-material/Search';
import {Search, HeaderUserName, HeaderUserRole, SearchIconWrapper, StyledInputBase, HeaderSubscriptText, StyledFlexEnd, StyledflexSpacebetween} from './Styled/index'
import history from '../Utility/history';
import { styled, useTheme } from '@mui/material/styles';
import { useSelector, useDispatch } from 'react-redux';
import SearchBoxControl from './HeaderSearbox';
import { createRequestData, getDocumentAsBlobUrl, getRequestData, updateRequestData } from '../Utility/apiHelper';
import { privateRoutesPath } from '../Routes';
import { useSnackbar } from 'notistack';
import { requestHideLoader, requestShowLoader } from '../Store/Global/action';
import { handleUpdatePermissionSet } from '../Store/User/action';
import Badge from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Divider } from '@mui/material';
import moment from 'moment';
import CircleIcon from '@mui/icons-material/Circle';
import bticon from '../Assets/images/biztantu-logo-full.png';
import sampleImage from '../Assets/images/biztantu-logo-bt.png';
// import Notificationred from '../Assets/images/notification_red.svg';
// import NotificationEmpty from '../Assets/images/notification_empty.svg';
import blankNot from '../Assets/images/mi_noti.png';
import notif from '../Assets/images/notification.png';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { handleValidateCodevalue } from '../Utility/constant';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { resolveNotificationRoute } from '../Utility/notificationRoute';

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme, open, drawerWidth }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
    //   width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: `${drawerWidth}px`,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  
const ResponsiveHeader = ({drawerWidth, open, handleDrawerOpen}) => {
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [anchorElnotification, setAnchorElnotification] = React.useState(null);
   
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const rolebasedData = useSelector(state => state?.owner?.rolebasedData);
    const [currentRole, setCurrentRole] = React.useState("");
    const[inputsearchvalue, setinputsearchvalue] = React.useState("");
    const organizationLabel = useSelector(state => state?.owner?.organizationLabel);
    const [messageList, setmessageList] = React.useState([]);
      const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    // console.log("currentUser",currentUser, rolebasedData);
    const [logoUrl, setLogoUrl] = React.useState(sampleImage);
    const [logoObjectUrl, setLogoObjectUrl] = React.useState(null);

    React.useEffect(() => {
  const loadLogo = async () => {
    const docId = currentUser?.client?.logoPath;
    if (!docId) {
      setLogoUrl(sampleImage);
      return;
    }
    try {
      const url = await getDocumentAsBlobUrl(docId);
      setLogoUrl(url || sampleImage);
    } catch (err) {
      console.error("Error loading logo:", err);
      setLogoUrl(sampleImage);
    }
  };
  loadLogo();
}, [currentUser?.client?.logoPath]);

    
    

    const {enqueueSnackbar} = useSnackbar();
    const dispatch = useDispatch();
    const handleOpenUserMenu = (event) => {
        console.log("handleOpenUserMenu")
        setAnchorElUser(event.currentTarget);
    };

    const handleOpenUserBell = (event) => {
        setAnchorElnotification(event.currentTarget);
    };

    const handleCloseUserBell = () => {
        console.log("closed the bell");
        // handlemarkAsSeenAllNotification();
        setAnchorElnotification(null);
    };



    const handlemarkAnItemasSeen = async(item) => {

        const url = `${process.env.REACT_APP_BASE_URL}notification/markAsSeen`;

        const {data} = await updateRequestData([item?.id],url);

        const updatedMessageList = messageList.map(notificationitem => {
            if(notificationitem?.id == item?.id) {
                return {
                    ...notificationitem,
                    seen: true
                }
            }

            return notificationitem
        })?.sort((a,b) => moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf())

        setmessageList(updatedMessageList);

           
    }

    React.useEffect(() => {
        if(currentUser) {
            let specificRole = "";
            const isLeadOperator = currentUser?.authorities?.find(item => item?.authority == "ROLE_leadoperator");
            const isAdmin = currentUser?.authorities?.find(item => item?.authority == "ROLE_admin")
            if(isAdmin && isLeadOperator) {
                specificRole = "Admin";
            } 

            if(isLeadOperator && !isAdmin) {
                specificRole = "Lead Operator"
            } 

            setCurrentRole(specificRole);
            
        }
    },[currentUser])

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleLogOut = () => {
        dispatch(handleUpdatePermissionSet());

        localStorage.removeItem('accessToken');
        history.push('/');
    }

    const handleviewprofile = () => {
        
    }


    const handleSearch = async() => {
        console.log("inputsearchvalue",inputsearchvalue);
        const searchreq = {
            "documentType" : "ALL",
            "searchWith" : {
                "any" : inputsearchvalue
            },
            "operator" : "OR"
        }

        dispatch(requestShowLoader());

        const url = `${process.env.REACT_APP_ELASTIC_SEARCH}search`;

        const responseData = await createRequestData(searchreq, url);

        if(responseData?.status == 'error') {
            // enqueueSnackbar('Please try again', {variant: 'error'})
            history.push({pathname: `${privateRoutesPath.GLOBAL_SEARCH}`, state: {searchString: inputsearchvalue}});
            dispatch(requestHideLoader());

            dispatch(requestHideLoader());

        } else {
            history.push({pathname: `${privateRoutesPath.GLOBAL_SEARCH}`, state: {responseData: responseData }});
            dispatch(requestHideLoader());

        }
    }

    const rendersecondry = (item) => {
        return (
            <StyledflexSpacebetween style={{margin: "0px"}}>
                <Typography variant='subtitle2' style={item?.seen ?{} : {fontWeight: 'bold', color: 'black'}}>
                    {item?.messagePrefix}{' '}
                    {handleValidateCodevalue(internationalise,item?.message)}
                </Typography>
                <Typography variant='subtitle2' style={item?.seen ? {} : {fontWeight: 'bold', color: 'black'}}>
                    {moment(item?.createdAt).format("DD MMM YYYY, hh:mm A")}
                </Typography>
            </StyledflexSpacebetween>
        )
    }

    const rendertitle = (item) => {
        return (
            <StyledflexSpacebetween style={{margin: "8px 0px"}}>
                <Typography variant='subtitle2' style={item?.seen ?{} : {fontWeight: 'bold'}}>
                    {item?.titlePrefix}{' '}
                    {handleValidateCodevalue(internationalise, item?.title)}
                </Typography>
                {!item?.seen && <Typography variant='subtitle2'>
                 <Tooltip title={handleValidateCodevalue(internationalise,"NOTI_MARK_AS_READ")}>
                    <CircleIcon  onClick = {() => handlemarkAnItemasSeen(item)} style={{color: "#1242C8", cursor: "pointer", fontSize:'20px'}}/>
                   
                 </Tooltip>
                    {/* {moment(item?.createdAt).format("DD MMM YYYY, hh:mm A")} */}
                </Typography>}
            </StyledflexSpacebetween>
        )
    }
    
        const location = useLocation(); 

     const handleOnClickNotification = (item) => {
         const route = resolveNotificationRoute(item);
         if (!route) return;

  handlemarkAnItemasSeen(item);

  history.push({
    pathname: route,
    state: { from: location.pathname },
  });
  handleCloseUserBell();
};

    return (
        <AppBar position="fixed" 
        open={open}
        drawerWidth={drawerWidth}
            sx={{ 
                zIndex: (theme) => theme.zIndex.drawer + 1 ,
                width: "98.5%",
                boxShadow: "none",
                borderRadius: "15px",
                margin: "0px 12px 0px 12px"
                // width: { sm: `calc(100% - ${drawerWidth}px)` },
                // ml: { sm: `${drawerWidth}px` },
            }}
        >
            <div maxWidth="xl" className='header-container'>
                <Toolbar disableGutters>
                    {/* <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        sx={{ mr: 2 }}
                    >
                            <MenuIcon />
                    </IconButton> */}
                    <Box sx={{width: '30%', display: 'flex'}}>
                        <div>
                            <img src= {bticon} style={{width: "36%", height: "100%", objectFit: 'contain'}}/> 
                            <b>ADMIN</b>
                        </div>
                
                    </Box>
                    {/* <Box sx={{width: '30%'}}>
                        <SearchBoxControl
                            onChange = {(event) => setinputsearchvalue(event.target.value)}
                            handleSearch = {handleSearch}
                        />
                    </Box> */}

                     {/* <Box>
                            <div style={{height: "28px", marginRight: "20px", display: "flex", alignItems: "center",}}>
                                 <img src={logoUrl} alt="org logo" style={{width: "auto", height: "100%", objectFit: "contain", display: "block",}}/>
                            </div>
                        </Box> */}
                       

                     <Box sx={{width: '30%', display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                          
                          <div style={{height: "55px",paddingRight : "30px"}}>
                                 <img src={logoUrl} alt="org logo" style={{width: "auto", height: "100%", objectFit: "contain", display: "block",}}/>
                            </div>

                        <Box sx={{marginRight: "4px", display: 'flex', justifyContent:'center',alignItems:'center',gap:1}}>
                        {/* <Tooltip> */}
                            <IconButton  sx={{ p: 0, float: 'right', display: 'flex', alignItems: 'flex-end' }} onClick={handleOpenUserMenu}>
                                <Avatar style={{backgroundColor: '#84C8FF', fontSize: "15px", color: "black", fontWeight: "bold"}} alt="Remy Sharp">
                                    {currentUser ? `${currentUser?.firstname?.[0]} ${currentUser?.lastname?.[0]}` : "L A"}
                                </Avatar>
                            </IconButton>
                        {/* </Tooltip> */}
                        <KeyboardArrowDownIcon style={{cursor: "pointer"}} onClick={handleOpenUserMenu}/>
                        </Box>
                        <Menu
                            sx={{ 
                                mt: '45px',
                                  ml : '35px',
                                height:'30%',
                                width : '40%',
                            '& .MuiPaper-root': {
                            borderRadius: '20px', 
                            overflow: 'hidden', 
                            },
                            }}
                            id="menu-appbar"
                            className='usersetting'
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                            >
                                <MenuItem
                                sx = {{
                                display:'flex',justifyContent:'center',
                                height : "90%",
                                width : "100%",
                                p: 0, // remove default padding
                                backgroundColor: 'grey', // grey background (MUI theme shade)
                                }}
                                    
                                    key='logout'>
                                <Box 
                                onClick={handleviewprofile}
                                sx = {{
                                     width: 'calc(100% - 20px)',margin:1, display:'flex',justifyContent:'space-between', alignItems:'space-between', padding : 2 , backgroundColor:'#F7F7F7',borderRadius:'20px'
                                    }}>
                                    <IconButton  sx={{ p: 0, float: 'right', display: 'flex', alignItems: 'flex-end' }}>
                                <Avatar style={{backgroundColor: '#84C8FF', fontSize: "15px", color: "black", fontWeight: "bold"}} alt="Remy Sharp">
                                    {currentUser ? `${currentUser?.firstname?.[0]} ${currentUser?.lastname?.[0]}` : "L A"}
                                </Avatar>
                            </IconButton>
                            <Box sx = {{ml:2, display:'flex' , alignItems:'flex-start',flexDirection:'column',flex: 1}}>
                                <Typography sx = {{fontWeight: 'bold', fontSize: '0.85rem'}} textAlign="center">{currentUser?.firstname} {currentUser?.lastname}</Typography>
                                    <Typography sx = {{fontSize: '0.65rem'}} textAlign="center">{currentUser?.username}</Typography>
                            </Box>
                                </Box>
                                </MenuItem>
                                {/* <MenuItem sx = {{display:'flex',justifyContent:'center'}} key='logout' onClick={handleviewprofile}>
                                    <Typography textAlign="center">My Profile</Typography>
                                </MenuItem> */}
                                <MenuItem sx = {{fontSize: '0.75rem',display:'flex',justifyContent:'center'}} key='logout' onClick={handleLogOut}>
                                    <Typography sx = {{fontWeight: 'bold', fontSize: '1 rem'}} textAlign="center">{handleValidateCodevalue(internationalise,'HEADER_PROFILE_LOG_OUT')}</Typography>
                                </MenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
            </div>
        </AppBar>
  );
};
export default ResponsiveHeader;
